import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import SolarCalculator from './page/SolarCalculator';
import {setPageLanguage, setPageTheme} from "./utils/util";
import {ThemeName, themes} from "./config/config";

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

setPageTheme((themes[window.location.hostname] || themes["default"]) as ThemeName).then(() => {
	setPageLanguage();
	root.render(
			<SolarCalculator/>
	);
})
